import { API_AUTH, API_AUTH_FILE } from "../common";

const ThongKeApi = {
  getSummaryThu: (filters) => {
    return API_AUTH.get(`api/thongke/SummaryThu`, filters);
  },
  getDetailsThu: (type, filters) => {
    const params = { type, ...filters };
    return API_AUTH.get(`api/thongke/DetailsThu`, params);
  },
  getChartDataThu: (filters) => {
    return API_AUTH.get(`api/thongke/ChartThu`, filters);
  },
  getSummaryChi: (filters) => {
    return API_AUTH.get(`api/thongke/SummaryChi`, filters);
  },
  getDetailsChi: (type, filters) => {
    const params = { type, ...filters };
    return API_AUTH.get(`api/thongke/DetailsChi`, params);
  },
  getChartDataChi: (filters) => {
    return API_AUTH.get(`api/thongke/ChartChi`, filters);
  },
  xuatBaoCao: (type, filters) => {
    const params = { type, ...filters };
    return API_AUTH_FILE.get("api/thongke/xuat-bao-cao", params, { responseType: 'blob' });
  },
  xuatBaoCaoChi: (type, filters) => {
    const params = { type, ...filters };
    return API_AUTH_FILE.get("api/thongke/xuat-bao-cao-chi", params, { responseType: 'blob' });
  },

  getPrintPreview: (thuChiId, templateKeyword) => {
    return API_AUTH.get(`api/thongke/print-preview/${thuChiId}`, { templateKeyword });
  },
  getDetailForModal: (thuChiId) => {
    return API_AUTH.get(`api/thongke/chi-tiet/${thuChiId}`);
  },

  getChiPrintPreview: (thuChiId, templateKeyword) => {
    return API_AUTH.get(`api/thongke/print-preview-chi/${thuChiId}`, { templateKeyword });
  },
  getDetailForChiModal: (thuChiId) => {
    return API_AUTH.get(`api/thongke/chi-tiet-chi/${thuChiId}`);
  },
  getThuDuKienSummary: (filters) => {
    return API_AUTH.get(`api/thongkethudukien/summary`, filters);
  },
  getThuDuKienDetails: (type, filters) => {
    const params = { type, ...filters };
    return API_AUTH.get(`api/thongkethudukien/details/`, params);
  },
  xuatBaoCaoThuDuKien: (type, filters) => {
    const params = { type, ...filters };
    return API_AUTH_FILE.get("api/thongkethudukien/xuat-bao-cao-thu-du-kien", params, { responseType: 'blob' });
  }
};

export default ThongKeApi;